export const COMMUNITY_ID = "communityId";
export const SELECTION_CRITERIA = "selectionCriteria";
export const DATE_RANGE = "dateRange";
export const YEAR = "year";
export const VENDOR = "vendorIds";
export const OWNER = "ownershipIds";
export const CLEARING_STATUS = "paidStatus";
export const GL_MASTER_IDS = "glMasterIds";

export const LEDGER = "LEDGER";
export const COST_ANALYTICS = "COST_ANALYTICS";
export const OWNER_OPTION = "Owner";
export const VENDOR_OPTION = "Vendor";
export const MONTHLY = "monthly";
export const YEARLY = "yearly";

export const selectionCriteriaOptions = [
  { value: MONTHLY, label: "Monthly" },
  { value: YEARLY, label: "Yearly" },
];

export const lineItemColumnOptions = [
  { key: "postingDate", label: "Posting Date", checked: true },
  { key: "postDocumentHeaderId", label: "Document Number", checked: true },
  { key: "lineNumber", label: "Line item id", checked: true },
  { key: "itemText", label: "Line item text", checked: true },
  { key: "debitAmount", label: "Debits", checked: true },
  { key: "creditAmount", label: "Credits", checked: true },
  { key: "documentDate", label: "Document Date", checked: true },
  { key: "documentType", label: "Doc Type", checked: true },
  { key: "costCenter", label: "Cost Center", checked: false },
  { key: "postingPeriod", label: "Posting Period", checked: false },
  { key: "currency", label: "Currency", checked: false },
  { key: "reference", label: "Reference", checked: false },
  { key: "invoiceNumber", label: "Invoice Number", checked: false },
  { key: "invoiceDate", label: "Invoice Dt", checked: false },
  { key: "clearingDocumentNumber", label: "Clearing Document Number", checked: false },
  { key: "clearingIndicator", label: "Clearing Indicator", checked: false },
  { key: "clearingDocumentDate", label: "Clearing Document Date", checked: false },
  { key: "baselineDate", label: "Baseline Date", checked: false },
  { key: "paymentTermName", label: "Payment Terms", checked: false },
  { key: "dueDate", label: "Due Date", checked: false },
  { key: "paymentMethodName", label: "Payment Method", checked: false },
  { key: "paymentDetails", label: "Payment Details", checked: false },
];